module.exports = __webpack_public_path__ + "web-assets/img/logo.92fb85e4.png";